export default "__VITE_ASSET__SVPP$omk__"